import { create } from "zustand";

const initialState = {
  showBomUsageLimit: true,
};

const useMainLayoutStore = create((set) => ({
  ...initialState,
  setShowBomUsageLimit: (payload) => {
    set({ showBomUsageLimit: payload });
  },
}));

export default useMainLayoutStore;
